import { ComponentService } from '../../../shared/abstract/component.service';
import { MediaMatcher } from '@angular/cdk/layout';
import {
  ChangeDetectorRef,
  Component,
  Injector,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthGuard } from '../../../shared/auth/auth.guard';
import { OverlayContainer } from '@angular/cdk/overlay';
import { AuthService } from '../../../shared/auth/auth.service';
import { Router } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import { AppsService } from '../../../shared/app.service';
import { Subscription } from 'rxjs';
import { SidemenuComponent } from './sidemenu/sidemenu.component';

@Component({
  selector: 'app-page-admin',
  templateUrl: './page-admin.component.html',
  styleUrl: './page-admin.component.css',
})
export class PageAdminComponent
  extends ComponentService<any>
  implements OnInit
{
  @ViewChild('sidenav') sidenav!: MatSidenav;
  @ViewChild('rightSidebar') rightSidenav!: MatSidenav;
  sidenavOpen: boolean = false;
  isSidenavOpened = true;
  @ViewChild(SidemenuComponent) sidemenu!: SidemenuComponent; // Access the SidemenuComponent
  @Input({ required: true }) isLoaded!: any;

  public mobileQuery: MediaQueryList;
  public isShowSidebar: boolean;
  public sidebarOpened: boolean = true; // or false, depending on default state
  private mobileQueryListener: () => void;
  constructor(
    injector: Injector,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public jwtHelper: JwtHelperService,
    private _authGuard: AuthGuard,
    public overlayContainer: OverlayContainer,
    private _auth: AuthService,
    private router: Router
  ) {
    super(injector);
    this.mobileQuery = media.matchMedia('(max-width: 430px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);

    this.isShowSidebar = !this.mobileQuery.matches;
  }


  onNotify(message: string) {

    if (message == 'toggle')
    {
      this.toggleSidenav();
    }

  }

  get routerClass(): string {
    if (this.mobileQuery.matches) {
      // On mobile, always small
      return 'router-class-small-sidemenu';
    } else {
      // On desktop, depends on isSidenavOpened
      return this.isSidenavOpened
        ? 'router-class-large-sidemenu'
        : 'router-class-small-sidemenu';
    }
  }

  ngOnInit(): void {}
  toggleSidenav() {
    this.isSidenavOpened = !this.isSidenavOpened;

    this.isSidenavOpened
      ? this.sidemenu.increase()
      : this.sidemenu.directDecrease();
  }
}
